<script>
import { getContext } from "svelte";
import { MENU_BAR_KEY, MENU_PANEL_KEY } from "./menuContext.js";
import { isMenuItemAllowed } from "@app/store/permissionStore.svelte.js";
import { getShortcutHint } from "@app/lib/menuShortcutHints.svelte.js";

/**
 * @type {{
 *   label?: string,
 *   icon?: string,
 *   onSelect?: () => void,
 *   disabled?: boolean,
 *   disabledReason?: string,
 *   shortcut?: string,
 *   shortcutHint?: string,
 *   checked?: boolean,
 *   href?: string,
 *   target?: string,
 *   rel?: string,
 *   id?: string,
 *   class?: string,
 *   children?: import('svelte').Snippet,
 * }}
 */
let {
    label = "",
    icon = "",
    onSelect,
    disabled = false,
    disabledReason = "",
    shortcut = "",
    shortcutHint = "",
    checked = false,
    href = "#!/",
    target = "",
    rel = "",
    id = "",
    class: className = "",
    children,
} = $props();

const menuBar = getContext(MENU_BAR_KEY);
const panel = getContext(MENU_PANEL_KEY);
let isAllowed = $derived(isMenuItemAllowed(panel?.menuId, id));
let hint = $derived(shortcutHint || (shortcut ? getShortcutHint(shortcut) : ""));
let isExternal = $derived(Boolean(href && href !== "#!/"));

function handleClick(event) {
    if (disabled) {
        event.preventDefault();
        return;
    }

    if (!isExternal) {
        event.preventDefault();
    }

    onSelect?.();
    menuBar.closeAll();
}
</script>

{#if isAllowed}
<a
    class={["dropdown-item", "cc-menu-item", className]}
    href={href}
    target={target || undefined}
    rel={target === "_blank" ? rel || "noreferrer" : rel || undefined}
    role="menuitem"
    tabindex="-1"
    aria-disabled={disabled}
    title={disabled && disabledReason ? disabledReason : undefined}
    id={id || undefined}
    onclick={handleClick}>
    <span class="cc-menu-item-icon" aria-hidden="true">
        {#if icon}
            <i class="bi {icon}"></i>
        {:else if checked}
            <i class="bi bi-check-lg"></i>
        {/if}
    </span>
    <span class="cc-menu-item-label">
        {#if children}
            {@render children()}
        {:else}
            {label}
        {/if}
    </span>
    {#if checked && icon}
        <i class="bi bi-check-lg" aria-hidden="true"></i>
    {/if}
    {#if hint}
        <span class="cc-menu-item-shortcut">{hint}</span>
    {/if}
</a>
{/if}

<style>
a.cc-menu-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.cc-menu-item[aria-disabled="true"] {
    opacity: 0.5;
    cursor: not-allowed;
}

.cc-menu-item-icon {
    width: 1.1em;
    flex-shrink: 0;
    text-align: center;
}

.cc-menu-item-label {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
}

.cc-menu-item-shortcut {
    margin-left: 1.25rem;
    opacity: 0.65;
    font-size: 0.75em;
    letter-spacing: 0.02em;
    white-space: nowrap;
}
</style>
